import { SyntheticEvent } from 'react'

export const wrapEvent = (
  theirHandler: React.EventHandler<SyntheticEvent<any>> | undefined,
  ourHandler: React.EventHandler<SyntheticEvent<any>>
) => (event: SyntheticEvent<any>) => {
  const result = theirHandler && theirHandler(event)

  // @ts-ignore
  if (result && result instanceof Promise) {
    event.persist()
    // @ts-ignore
    ;(result as Promise<void>).then(() => {
      if (!event.defaultPrevented) {
        return ourHandler(event)
      }
    })
  } else {
    if (!event.defaultPrevented) {
      return ourHandler(event)
    }
  }
}

export default wrapEvent
